var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStadiumOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StadiumOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.33329 4.16675L2.99996 5.83342V2.50008L6.33329 4.16675ZM15.5 2.50008V5.83342L18.8333 4.16675L15.5 2.50008ZM9.66663 1.66675V5.00008L13 3.33341L9.66663 1.66675ZM11.3333 15.0001H9.66663V18.3334C5.45829 18.2084 2.16663 17.1334 2.16663 15.8334V8.33342C2.16663 6.95008 5.89996 5.83342 10.5 5.83342C15.1 5.83342 18.8333 6.95008 18.8333 8.33342V15.8334C18.8333 17.1334 15.5416 18.2084 11.3333 18.3334V15.0001ZM4.66663 8.36675C5.81663 8.77508 7.80829 9.16675 10.5 9.16675C13.1916 9.16675 15.1833 8.77508 16.3333 8.36675C16.3333 8.21675 14.0166 7.50008 10.5 7.50008C6.98329 7.50008 4.66663 8.21675 4.66663 8.36675ZM17.1666 9.83342C15.65 10.4417 13.225 10.8334 10.5 10.8334C7.77496 10.8334 5.34996 10.4417 3.83329 9.83342V15.4834C4.34163 15.8251 5.79996 16.3251 7.99996 16.5501V13.3334H13V16.5501C15.2 16.3251 16.6583 15.8251 17.1666 15.4834V9.83342Z",
    fill: "#009FDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadiumOutlined);
export default __webpack_public_path__ + "static/media/StadiumOutlined.a1d6996c5b7f4a4184c8ecadb6d39bc1.svg";
export { ForwardRef as ReactComponent };